module.exports = __webpack_public_path__ + "img/slate_logo.7982191a.png";